module.exports = __webpack_public_path__ + "media/npc_dota_hero_morphling.91642506.webm";